import React from 'react';
import {createSvgIcon} from '@common/icons/create-svg-icon';

export const CustomFlipIcon = createSvgIcon(
  <path d="M 11 3 L 2 21 L 11 21 L 11 3 z M 13 3 L 13 21 L 22 21 L 13 3 z M 9 11.472656 L 9 19 L 5.2363281 19 L 9 11.472656 z" />
);
